import { render, staticRenderFns } from "./QuranRadios.vue?vue&type=template&id=f8d40b1c&scoped=true&"
import script from "./QuranRadios.vue?vue&type=script&lang=js&"
export * from "./QuranRadios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d40b1c",
  null
  
)

export default component.exports